export const adaptiveTestSectionNames = {
  firstSection: 'SECTION 1',
  secondSection: 'SECTION 2',
}
